import { render } from "./SearchWithDateRange.vue?vue&type=template&id=2255ef57"
import script from "./SearchWithDateRange.vue?vue&type=script&lang=js"
export * from "./SearchWithDateRange.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__